<img
  *ngIf="profileAvatarInfo?.ImageSource; else svg"
  class="avatar-img {{ size }}"
  [ngClass]="imgClassObject"
  [ngStyle]="style"
  [src]="profileAvatarInfo?.ImageSource"
/>

<ng-template #svg>
  <svg
    *ngIf="profileAvatarInfo?.IsOrg || isOrg"
    class="{{ size }} {{ iconColor }}"
    [ngStyle]="style"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
  >
    <path
      d="M19 14.5V27h17v15h20V2H19v12.5zm24-5c0 .8-.7 1.5-1.5 1.5S40 10.3 40 9.5 40.7 8 41.5 8s1.5.7 1.5 1.5zm8 0c0 .8-.7 1.5-1.5 1.5S48 10.3 48 9.5 48.7 8 49.5 8s1.5.7 1.5 1.5zm-8 8c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm8 0c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5z"
    />
    <path
      d="M6 50.5V70h25V31H6v19.5zm9-7c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm8 0c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm-8 9c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm8 0c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm-8 9c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm8 0c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zM36 58v12h29V46H36v12z"
    />
  </svg>

  <svg
    *ngIf="(profileId && !profileAvatarInfo?.IsOrg) || (!profileId && !isOrg)"
    class="{{ size }} {{ iconColor }}"
    [ngStyle]="style"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
  >
    <path
      d="M18 0C8.064 0 0 8.064 0 18C0 27.936 8.064 36 18 36C27.936 36 36 27.936 36 18C36 8.064 27.936 0 18 0ZM18 5.4C20.988 5.4 23.4 7.812 23.4 10.8C23.4 13.788 20.988 16.2 18 16.2C15.012 16.2 12.6 13.788 12.6 10.8C12.6 7.812 15.012 5.4 18 5.4ZM18 30.96C13.5 30.96 9.522 28.656 7.2 25.164C7.254 21.582 14.4 19.62 18 19.62C21.582 19.62 28.746 21.582 28.8 25.164C26.478 28.656 22.5 30.96 18 30.96Z"
    />
  </svg>
</ng-template>
